import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import NovaOrb from "@/components/NovaOrb";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0f0f2e] flex flex-col items-center justify-center p-6 text-center">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-[#8B5CF6]/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-[#EC4899]/5 rounded-full blur-[100px]" />
      </div>
      <div className="relative z-10 max-w-md space-y-6">
        <NovaOrb state="idle" stage={1} size="lg" />
        <div className="space-y-2">
          <h1 className="text-5xl font-display font-bold text-white" data-testid="text-404-title">404</h1>
          <p className="text-xl font-medium text-slate-300" data-testid="text-404-subtitle">Page not found</p>
          <p className="text-sm text-slate-500" data-testid="text-404-message">
            This page doesn't exist or may have been moved.
          </p>
        </div>
        <div className="flex items-center justify-center gap-3 pt-2">
          <Button
            onClick={() => window.history.length > 1 ? window.history.back() : (window.location.href = "/")}
            variant="outline"
            className="rounded-full border-white/10 text-slate-300 hover:text-white hover:bg-white/10 gap-2"
            data-testid="button-404-back"
          >
            <ArrowLeft className="w-4 h-4" /> Go Back
          </Button>
          <Link href="/">
            <Button className="bg-[#8B5CF6] hover:bg-[#7C3AED] text-white rounded-full gap-2 shadow-lg shadow-[#8B5CF6]/20" data-testid="button-404-home">
              <Home className="w-4 h-4" /> Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
